import Cookies from "js-cookie";
import axiosVanilla from "axios";
import axios from "@lib/axios";
import gtm from "@lib/gtm";
import isServer from "@utils/is-server";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { identifyUserForCustomerIO } from "@utils/identifyUserForCustomerIO";
import { setCustomizableCloset } from "./customizable-closet-actions";
import { getAddressesAction } from "./address-actions";
import { getReferralsRewardsAction } from "./referral-rewards-actions";
import { initializePendingCart } from "./cart-actions";
import { getProductsLiked, getProductsRented } from "./user-actions";

export const TYPES = {
  SIGN_IN: "SIGN_IN",
  SIGN_OUT: "SIGN_OUT",
};

export function signInUser(user) {
  return { type: TYPES.SIGN_IN, user };
}

export function signOutUser() {
  return { type: TYPES.SIGN_OUT };
}

function cookieRemoveJwtToken() {
  Cookies.remove("jwt-token", { domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN });
  Cookies.remove("jwt-token");
}

export function signIn(authObject) {
  cookieRemoveJwtToken();
  return (dispatch) =>
    axios.post("users/sign_in", authObject).then(({ data: { data: user } }) => {
      ahoy("identify");
      identifyUserForCustomerIO(user);
      if (user.just_created) {
        gtm({ event: "signinsuccess" }, user);
        // eslint-disable-next-line no-param-reassign
        user.just_created = false;
      }
      setCustomizableCloset(dispatch);
      getAddressesAction(dispatch);
      getReferralsRewardsAction(dispatch);
      initializePendingCart(dispatch);
      dispatch(getProductsLiked());
      dispatch(getProductsRented());

      return dispatch(
        signInUser({
          ...user,
          just_created: true,
        }),
      );
    });
}

export function signUp(authObject) {
  cookieRemoveJwtToken();
  return (dispatch) =>
    axios.post("users/sign_up", authObject).then(({ data: { data: user } }) => {
      ahoy("identify");
      identifyUserForCustomerIO(user);
      if (user.just_created) {
        gtm({ event: "signupsuccess" }, user);
        // eslint-disable-next-line no-param-reassign
        user.just_created = false;
      }

      dispatch(getProductsLiked());
      dispatch(getProductsRented());

      return dispatch(
        signInUser({
          ...user,
          just_created: true,
        }),
      );
    });
}

export function signOut() {
  return async (dispatch) => {
    cookieRemoveJwtToken();
    delete axios.defaults.headers.common.Authorization;
    analytics.reset();
    await dispatch(signOutUser());
  };
}

export function logUserWithToken(jwt) {
  return async (dispatch) => {
    if (!jwt) return null;

    try {
      const {
        data: { data: user },
      } = await axiosVanilla.get(
        `${
          isServer() && process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
            ? process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
            : process.env.NEXT_PUBLIC_API_URL
        }/profile?ref=1`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "X-App-Origin": "NextJs",
            "X-App-Version": process.env.HEROKU_RELEASE_VERSION,
          },
        },
      );
      setCustomizableCloset(dispatch);
      getAddressesAction(dispatch);
      getReferralsRewardsAction(dispatch);
      initializePendingCart(dispatch);
      dispatch(getProductsLiked());
      dispatch(getProductsRented());
      identifyUserForCustomerIO(user);

      await dispatch(signInUser(user));
      return user;
    } catch (err) {
      cookieRemoveJwtToken();
      await dispatch(signOutUser());
      return null;
    }
  };
}

export async function resetPassword(email) {
  return axios.post("users/password", { user: { email } });
}

export function updatePassword(data) {
  return axios.put("users/password", { user: data });
}
